module.exports = __webpack_public_path__ + "static/media/icon-order-success.10994460.svg";